import type { HousingSelectionType } from '../housing-selection/housingSelectionTypes';

export const describeProperty = ({ bedrooms, bathrooms, areaSquareFeet }: HousingSelectionType) =>
  [bedrooms && `${bedrooms} BD`, bathrooms && `${bathrooms} BA`, areaSquareFeet && `${areaSquareFeet} sq. ft`]
    .filter(Boolean)
    .join(' / ');

export const getPropertyNameFull = (address: HousingSelectionType) =>
  address.line1 !== ''
    ? [getPropertyNameFirstPart(address), getPropertyNameSecondPart(address)].filter(Boolean).join(', ')
    : address.full;

export const getPropertyNameFirstPart = ({ line1, line2 }: HousingSelectionType) =>
  [line1 && `${line1}`, line2 && `${line2}`].filter(Boolean).join(', ') || 'Unknown';

export const getPropertyNameSecondPart = ({ city, state, zipCode }: HousingSelectionType) =>
  [city && `${city}`, state && zipCode && `${state} ${zipCode}`].filter(Boolean).join(', ') || 'Unknown';
